// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8iTJI","badges":"styles_badges__2qzJm"};